export default __webpack_public_path__ + "static/media/prashant.4643f5cb.png";